/**
 * Shared text-formatting helpers used across the app's forms.
 */

/**
 * Capitalize the first letter of each word; lowercase everything else. Also trims the ends and
 * collapses runs of whitespace to a single space.
 *
 *   "adil waheed"      → "Adil Waheed"
 *   "MUHAMMAD AHMAD"   → "Muhammad Ahmad"
 *   "anna-marie"       → "Anna-Marie"
 *   "chak 51"          → "Chak 51"
 *   "test "            → "Test"
 *   "muhammad  ahmad"  → "Muhammad Ahmad"
 *
 * Used on blur for names, addresses, and similar identifier-like text fields so
 * the saved value is consistently capitalized regardless of how the user typed it.
 *
 * The whitespace squeeze matters as much as the casing: a stray trailing space in a first name
 * used to be stored verbatim, and since patient search matches against "first + ' ' + last", it
 * produced a double space that no full-name search could match through. Normalizing on blur means
 * the user sees the cleaned value before saving. The backend normalizes again on write.
 *
 * Do NOT use this on:
 *   - free-text fields (descriptions, notes, instructions) — preserve user casing
 *   - identifier-format fields (CNIC, phone, dates) — no case applies
 *   - user-controlled labels (tags) — preserve case the user chose
 *   - emails — case can be significant
 */
export const toTitleCase = (s) =>
  String(s || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
